import getExtensibilityState from '../store/getExtensibilityState';
import IAddinCommand from '../store/schema/interfaces/IAddinCommand';
import { ObservableMap } from 'mobx';
import IExtendedAddinCommand from '../store/schema/interfaces/IExtendedAddinCommand';
import IAddinCommandTelemetry from '../store/schema/interfaces/IAddinCommandTelemetry';

export function isAnyUilessAddinRunning(hostItemIndex: string): boolean {
    return getExtensibilityState().runningUILessExtendedAddinCommands.has(hostItemIndex);
}

export function getUilessAddinCommand(controlId: string): IAddinCommand {
    const addins = getRunningUilessAddins();
    for (const hostItem of addins.values()) {
        for (const uilessControlId of hostItem.keys()) {
            if (uilessControlId === controlId) {
                return hostItem.get(uilessControlId).addinCommand;
            }
        }
    }
    return null;
}

export function getUilessAddinCommandTelemetry(
    hostItemIndex: string,
    controlId: string
): IAddinCommandTelemetry {
    if (
        getRunningUilessAddins().has(hostItemIndex) &&
        getRunningUilessAddins()
            .get(hostItemIndex)
            .has(controlId)
    ) {
        return getRunningUilessAddins()
            .get(hostItemIndex)
            .get(controlId).addinCommandTelemetry;
    }
    return null;
}

export function getUilessHostItemIndex(controlId: string): string {
    const addins = getRunningUilessAddins();
    for (const hostItemIndex of addins.keys()) {
        const hostItem = addins.get(hostItemIndex);
        for (const uilessControlId of hostItem.keys()) {
            if (uilessControlId === controlId) {
                return hostItemIndex;
            }
        }
    }
    return null;
}

export function isUilessAddinRunning(controlId: string): boolean {
    return getUilessAddinCommand(controlId) !== null;
}

function getRunningUilessAddins(): ObservableMap<
    string,
    /*key: hostItemIndex*/ ObservableMap<string, /*key: controlId*/ IExtendedAddinCommand>
> {
    return getExtensibilityState().runningUILessExtendedAddinCommands;
}
